let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a9fiu")).then(() => parcelRequire('2LlB2'));